/**
 * Durante react-snap, risponde da window.snapStore senza rifare le fetch.
 * Nel browser reale NON intercetta: altrimenti SPA e hard-refresh si comportano
 * in modo diverso e i dati snap di una pagina possono “sporcare” altre route.
 */
import { getSnapApiData, isReactSnap } from '../utils/snapStore';

function buildSnapKey(config) {
  const base = (config.baseURL || '').replace(/\/$/, '');
  let url = config.url || '';
  if (url.startsWith('http')) {
    try {
      const u = new URL(url);
      return u.pathname + (u.search || '');
    } catch {
      return url;
    }
  }
  if (!url.startsWith('/')) url = `/${url}`;
  return `${base}${url}`.replace(/([^:]\/)\/+/g, '$1');
}

function findSnapPayload(config) {
  if (typeof window === 'undefined' || !window.snapStore) return undefined;
  const key = buildSnapKey(config);
  if (window.snapStore[key] !== undefined) return window.snapStore[key];
  const pathOnly = key.replace(/^\/api\/v1/, '') || key;
  // Solo match esatto (o con query identica già nella key) — niente prefix su /medici/123
  return getSnapApiData(pathOnly);
}

export function attachSnapStoreAdapter(axiosInstance) {
  axiosInstance.interceptors.request.use((config) => {
    if (!isReactSnap()) return config;

    const data = findSnapPayload(config);
    if (data === undefined) return config;

    config.adapter = () =>
      Promise.resolve({
        data,
        status: 200,
        statusText: 'OK',
        headers: { 'content-type': 'application/json' },
        config,
        request: {},
      });

    return config;
  });
}
